import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const forkliftLocaleModule: LocaleModule = {
  name: "forklift",
  messages: { en: en, it: it },
};
